import { jsx, jsxs } from 'react/jsx-runtime';
import { FlexBox, Typography, tokens, Callout } from '@vp/swan';
import { useTranslations as $ } from './contact-channels43.js';
import { Loader as y } from './contact-channels94.js';
import { useCallMe as J } from './contact-channels4.js';

const v=t=>{const{customTitle:l,showBadge:n=true,variation:s="minimal"}=t,{t:i}=$(),{data:e,isLoading:r,isPending:a}=J();return jsx(y,{skeletonLines:1,skeletonLineWidths:"narrow",isLoading:r||a,children:jsxs(FlexBox,{justifyContent:"space-between",alignItems:"flex-start",children:[jsx(Typography,{fontSkin:"title-subsection",style:{color:e!=null&&e.isAvailable?void 0:tokens.SwanSemColorTextDisabled},children:l||i(`call_me.title.${s}`)}),n&&(e==null?void 0:e.isAvailable)&&jsx(Callout,{children:i("call_me.badge")})]})})};

export { v as CallMeHeader };
//# sourceMappingURL=contact-channels24.js.map
